export * from './analitica.config'
